module.exports = __webpack_public_path__ + "img/the-netherlands-tuberculosis-male.43e4c9ee.png";